import { createContext, ReactNode, useContext, useState } from 'react'

const EditingRowsContext = createContext<{
  currentlyEditingRow: string | null
  setCurrentlyEditingRow: (editingRowId: string | null) => void
}>({
  currentlyEditingRow: null,
  setCurrentlyEditingRow: () => {},
})

export const useEditingRowsContext = () => useContext(EditingRowsContext)

export const RowEditingProvider = ({ children }: { children: ReactNode }) => {
  const [currentlyEditingRow, setCurrentlyEditingRow] = useState<string | null>(null)

  return (
    <EditingRowsContext.Provider value={{ currentlyEditingRow, setCurrentlyEditingRow }}>{children}</EditingRowsContext.Provider>
  )
}
